import { Heading, Box } from 'braid-design-system';

type HeadingProps = Parameters<typeof Heading>[0];

export interface Props {
  title: string;
  level?: HeadingProps['level'];
  align?: HeadingProps['align'];
}

const PageHeading = ({ title, level = '2', align = 'left' }: Props) => (
  <Box
    paddingTop={['medium', 'xlarge']}
    paddingBottom={'medium'}
    paddingX={['gutter', 'none']}
  >
    <Heading level={level} align={align}>
      {title}
    </Heading>
  </Box>
);

export default PageHeading;
